import { Col, Row } from "antd";
import { useState } from "react";
import ComponentList from "./componentList";
import { AddEditComponent } from "./AddEditComonent";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { getComponentsApi } from "../../../api/refcomponents";
import { useMutation } from "react-query";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";

const Components = () => {
  const [openComponent, setOpenComponent] = useState(false);
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedtComponent, setPaginatedtComponent] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");

  const resetFilters = () => {
    gettComponent({
      limit: page * 8 + 8,
      q: "",
    }).then((res) => {
      setPaginatedtComponent(res.data?.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    gettComponent({
      limit: page * 8 + 8,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedtComponent(res.data?.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    gettComponent({
      limit: page * 8 + 8,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedtComponent(res.data?.data);
    });
  };

  const gettComponent = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await ComponentMutation(params);
  };

  const { mutateAsync: ComponentMutation, isLoading: istComponentLoading } =
    useMutation("components", getComponentsApi);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => setOpenComponent(true)} />
        </Col>
        <Col span={24}>
          <ComponentList
            tableKey={tableKey}
            setPage={setPage}
            page={page}
            filter={filter}
            search={search}
            istComponentLoading={istComponentLoading}
            paginatedtComponent={paginatedtComponent}
            setPaginatedtComponent={setPaginatedtComponent}
            ComponentMutation={ComponentMutation}
          />
        </Col>
      </Row>
      {openComponent && (
        <AddEditComponent
          openComponent={openComponent}
          setOpenComponent={setOpenComponent}
          setPaginatedtComponent={setPaginatedtComponent}
          ComponentMutation={ComponentMutation}
          page={page}
          filter={filter}
          search={search}
        />
      )}
    </>
  );
};

export default Components;
